import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { QrReader } from 'react-qr-reader';

const MESSAGE_CAM_PERMISSION_DENIED =
  'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.';

export const QrCodeReader = ({ param }) => {
  const [error, setError] = useState(null);
  const disabledRef = useRef(false);

  const handleScan = (result) => {
    if (disabledRef.current) return;
    if (result) {
      disabledRef.current = true;
      param.showHideModal();
      param.onClick(result);
    }
  };

  const handleError = (error) => {
    setError(error.message);
  };

  const requestPermission = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setError(null);
      stream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      if (err?.name === 'NotAllowedError' || err?.message === MESSAGE_CAM_PERMISSION_DENIED) {
        setError(
          `Acesso à câmera bloqueado nas configurações do navegador.\n\nPor favor, permita o acesso à câmera nas configurações de privacidade do seu navegador e tente novamente.`,
        );
      }
      // throw err;
    }
  }, []);

  return (
    <>
      {error && (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <h2 style={{ paddingBottom: 40 }}>
            {error.replace(
              MESSAGE_CAM_PERMISSION_DENIED,
              'Acesso à câmera negado.\n\nPrecisamos do acesso para poder escanear o QRCode da sua comanda.',
            )}
          </h2>
          {!error.includes('Acesso à câmera bloqueado nas configurações do navegador.') ? (
            <a onClick={() => requestPermission()} style={{ padding: 40, textAlign: 'center', width: '100%' }}>
              Autorizar
            </a>
          ) : null}
        </div>
      )}

      {!error && (
        <>
          <video id="video"></video>

          <QrReader
            videoId="video"
            constraints={{ facingMode: 'environment' }}
            scanDelay={500}
            containerStyle={{
              height: '100%',
              width: '100%',
            }}
            onResult={(result, error) => {
              if (result) {
                handleScan(result?.text);
              }

              if (error) {
                handleError(error);
              }
            }}
            style={{ width: '100%' }}
          />
        </>
      )}
    </>
  );
};

QrCodeReader.propTypes = {
  param: PropTypes.object,
};
